import { useState } from "react";
import { FcPrevious, FcNext } from "react-icons/fc";

const Paginator = (props) =>{
  const [workingPage, setWorkingPage] = useState(1);
 
    const next = ()=>{
        
        if(workingPage< props.lastPage){
        
            
            props.pageChanged(workingPage +1);
            setWorkingPage(workingPage + 1);
           
            //alert("Last page=" + props.lastPage + "current page: " + page);
        }
        
    }
    const prev = ()=>{
        if(workingPage >= 1){
            
            setWorkingPage(workingPage - 1);
            props.pageChanged(workingPage);
            
        }
        
    }

  // const fromValues = workingPage*20;


    const footerNumbers =()=>{
      if(props.lastPage > 2){
        return (
          <>
          <li>
            <button
              className="px-3 py-1 rounded-md focus:outline-none focus:shadow-outline-purple"
            >
              2
            </button>
          </li>

          <li>
          <button
            className="px-3 py-1 text-white transition-colors duration-150 bg-teal-700 border border-r-0 border-teal-700 rounded-md focus:outline-none focus:shadow-outline-teal"
          >
            3
          </button>
          </li>
          </>  

        );
      }else{

      }
    }

    return (
        <div className="grid px-4 py-3 text-xs font-semibold tracking-wide text-gray-500 uppercase border-t dark:border-gray-700 bg-gray-50 sm:grid-cols-9 dark:text-gray-400 dark:bg-gray-800" >
                <span className="flex items-center col-span-3">
                  {/* Showing {fromValues} 21-30 of 100 */}
                </span>
                <span className="col-span-2"></span>
                {/* <!-- Pagination --> */}
                <span className="flex col-span-4 mt-2 sm:mt-auto sm:justify-end">
                  <nav aria-label="Table navigation">
                    <ul className="inline-flex items-center">
                      <li>
                        <button className="px-3 py-1 rounded-md rounded-l-lg focus:outline-none focus:shadow-outline-purple" aria-label="Previous" onClick={prev} >
                          <FcPrevious />
                        </button>
                      </li>
                       {/* {footerNumbers} */}
                        
                      <li>
                        <button
                          className="px-3 py-1 rounded-md rounded-r-lg focus:outline-none focus:shadow-outline-purple"
                          aria-label="Next"  onClick={next} 
                        >
                          <FcNext />
                        </button>
                      </li>
                    </ul>
                  </nav>
                </span>
              </div>
             
        );
}

export default Paginator;